var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 375",
    opacity: 0.85,
    className: "w-full h-full",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bbblurry-filter",
    x: "-100%",
    y: "-100%",
    width: "400%",
    height: "400%",
    filterUnits: "objectBoundingBox",
    primitiveUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 130,
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    in: "SourceGraphic",
    edgeMode: "none",
    result: "blur"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#bbblurry-filter)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 277.5,
    ry: 128.5,
    cx: 210.29769620028412,
    cy: 383.7445401278409
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 277.5,
    ry: 128.5,
    cx: 30.722625732421875,
    cy: 367.08941927823156
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 277.5,
    ry: 128.5,
    cx: 388.99638505415476,
    cy: 431.1856772682884
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 277.5,
    ry: 128.5,
    cx: 54.41040039062494,
    cy: 433.54682090065694
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur);
export default __webpack_public_path__ + "static/media/blur.1c34099a712e1a7ec54ee6ce617be888.svg";
export { ForwardRef as ReactComponent };